export const LOG_IN = '/logIn';
export const ROOT = '/';
export const DEBUG = '/debug';

export const REPORTS_ROOT = '/reports';

export const REPORTS_VIEW = `${REPORTS_ROOT}/:id/view`;
